<script setup>
import { registeredFacets } from "../SessionFacets.js";

import PanelContainer from "@/components/ExperiencePage/Algolia/AlgoliaPanelContainer.vue";
import CheckboxFilter from "@/components/MyStudents/Filters/CheckboxFilter.vue";
import CurrentRefinementCount from "@/components/MyStudents/Display/CurrentRefinementCount.vue";
import SessionMinMaxSlider from "./SessionMinMaxSlider.vue";
import SessionDateSearch from "./SessionDateSearch.vue";

const registeredComponents = {
  CheckboxFilter,
  SessionMinMaxSlider,
  SessionDateSearch,
};
</script>

<template>
  <template v-for="facet in registeredFacets">
    <div class="flex flex-col items-center w-full py-2 border-b border-gray-300">
      <panel-container
        :id="facet.paramName"
        :title="facet.title"
        main-panel-class="w-full"
        :panel-button-text-classes="['font-light normal-case']"
        heading-class="w-full py-3 text-sm items-center"
      >
        <component
          :is="registeredComponents[facet.component]"
          :filter-attribute="facet.attribute"
          :searchable="facet.searchable ?? false"
        />
        <template #title>
          <current-refinement-count :attribute="facet.attribute" />
        </template>
      </panel-container>
    </div>
  </template>
</template>

